<div class="dialog-container compact">
  <section class="dialog-header">
    <div class="title">{{title | translate}}</div>
  </section>

  <section class="dialog-content pb-4">
    <div class="group-container input-fields-container">
      @if (isEditMode) {
        <input #nameInputField
          type="text"
          maxlength="256"
          class="comment-field
            w-full
            border-none
            outline-none
            text-base
            font-normal
            py-2
            px-3
            rounded-t
            bg-gray-50
            ring-1
            ring-gray-200
            hover:ring-1
            [&:not(:focus)]:hover:ring-primary-hover
            focus:ring-1
            focus:ring-primary
            invalid:ring-1
            invalid:ring-warn
            placeholder:text-gray-600
            placeholder:font-light
            placeholder:text-sm"
          [placeholder]="'Wizard.Panel.Comments.Placeholder' | translate"
          [formControl]="commentControl"
          (keyup.enter)="handleValidateAndClose($event)">
      } @else {
        <div class="w-full text-base font-normal">
          {{comment}}
        </div>
      }
    </div>
  </section>

  <section class="dialog-footer">
    @if (isEditMode) {
      <button mirButton xs tabindex="0"
          (click)="handleCancel($event)">
        {{'UI.Cancel' | translate}}
      </button>
    }
    <button mirButton stroked xs accent tabindex="0"
        (click)="handleValidateAndClose($event)">
      <MirIcon>check</MirIcon>
      @if (isEditMode) {
        {{'UI.Validate' | translate}}
      } @else {
        {{'UI.OK' | translate}}
      }
    </button>
  </section>
</div>
